import { FormikProvider, Formik, Form, useFormik, ErrorMessage } from 'formik'
import { Link, Redirect, useHistory } from 'react-router-dom'
import { useAuthState, useAuthDispatch, authThunks, useAuthSelector } from '../../stores/hooks'
import React, { useEffect, useState } from 'react'
import NewDriverLogo from '../../assets/New_Driver.png'

import styled from '@emotion/styled'

import { ButtonLoader } from '../../components/ButtonLoader'
import { styles } from '../../components/Styles'
import { Yup } from '../../components/Yup'
import { TextField } from '../../components/TextField'
import { Button } from 'antd'
import { selectTokenValid } from '../../stores/authStore'

export interface IValues {
  cpf: string
  pwd: string
}

export function LoginView() {
  const dispatch = useAuthDispatch()
  const { request } = useAuthState()
  const isAuthenticated = useAuthSelector(selectTokenValid)
  const history = useHistory()

  const formik = useFormik({
    initialValues: { cpf: '', pwd: '' },
    onSubmit: (values, meta) => {
      const cpf = values.cpf
      const pwd = values.pwd
      dispatch(authThunks.login({ cpf, pwd }))
    },
    validationSchema: Yup.object().shape({
      cpf: (Yup as any).string().required().cpf(),
      pwd: Yup.string().required(),
    }),
    validateOnChange: true,
    validateOnBlur: true,
  })

  useEffect(() => {
    if (isAuthenticated) {
      history.push('/inicio')
    }
  }, [isAuthenticated])

  return (
    <Container>
      <Content>
        <img src={NewDriverLogo} style={{ width: 150, marginBottom: 24 }} />
        <FormikProvider value={formik}>
          <Form>
            <TextField mask="cpf" label="Login" name="cpf" placeholder="CPF" />
            <br />
            <TextField
              onKeyPress={(e) => {
                if (e.key === 'Enter') formik.handleSubmit()
              }}
              name="pwd"
              type="password"
              label="Senha"
              placeholder="Informa a senha"
            />
            <br />
            <ButtonLoader disabled={request.fetching} loading={request.fetching} htmlType="submit">
              Enviar
            </ButtonLoader>
          </Form>
        </FormikProvider>

        <ContainerEsqueceuSenha>
          <Link to="/esqueceu-senha">Esqueceu sua senha?</Link>
        </ContainerEsqueceuSenha>
      </Content>
    </Container>
  )
}

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-content: center;
  height: 100vh;
  background: #f3f3f3;
`

const Content = styled('div')`
  width: 450px;
  margin: auto;
`

const ContainerEsqueceuSenha = styled('div')`
  text-align: center;
  padding: 12px;
  text-shadow: 1px 1px 0 #333;
  a {
    color: ${styles.color.white};
  }
`
